export default "__VITE_ASSET__HF4PnQQJ__"